import { render, staticRenderFns } from "./live-lecture.vue?vue&type=template&id=6ba7315c&scoped=true"
import script from "./live-lecture.vue?vue&type=script&lang=js"
export * from "./live-lecture.vue?vue&type=script&lang=js"
import style0 from "./live-lecture.vue?vue&type=style&index=0&id=6ba7315c&prod&scoped=true&lang=css"
import style1 from "./live-lecture.vue?vue&type=style&index=1&id=6ba7315c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba7315c",
  null
  
)

export default component.exports